<div class="button-wrapper">
  <div *ngIf="isSuperAdmin" class="return-wrapper">
    <a routerLink="/dashboard/tenants" class="return"><i id="icon-chevron" class="fas fa-chevron-left"></i> {{'BACK' | translate}}</a>
  </div>
  <a class="filter-button" [class.active]="showCoaches" (click)="showCoaches = true">{{ 'COACHES' | translate }}</a>
  <a class="filter-button" [class.active]="!showCoaches" (click)="showCoaches = false">{{ 'BILLED_CLIENTS' | translate }}</a>
  <a class="new-coach-button" *ngIf="showCoaches" [routerLink]="['./new-coach']">{{"NEW_COACH" | translate}}</a>
</div>

<table class="client-table" *ngIf="showCoaches">
  <thead>
    <tr>
      <th>{{'NAME' | translate}}</th>
      <th>{{'EMAIL' | translate}}</th>
      <th [width]="100" class="center">{{'ACTIVE' | translate}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let coach of coaches" [routerLink]="['coach', coach.id]">
      <td>{{ coach.firstName + ' ' + coach.lastName }}</td>
      <td>{{ coach.email }}</td>
      <td *ngIf="coach.isActive" class="center color-green"><i class="fa-solid fa-check"></i></td>
      <td *ngIf="!coach.isActive" class="center color-red"><i class="fa-solid fa-x"></i></td>
    </tr>
  </tbody>
</table>

<table class="client-table" *ngIf="!showCoaches">
  <thead>
    <tr>
      <th>{{'DATE' | translate}}</th>
      <th>{{ 'NUMBER_OF_CLIENTS' | translate }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let month of anonymizedBilledClientsPerMonth">
      <td>{{ month.date | date: 'MMMM YYYY' }}</td>
      <td>{{ month.clientIds.length }}</td>
    </tr>
  </tbody>
</table>
